import App from '@nrdy-marketing-engine/server/pages/_app';
import '@nrdy-marketing-engine/theming/styles/global.css';

export default App;
